<template>
  <div>
    <van-nav-bar fixed title="提交评价" left-arrow @click-left="goBack"/>
    <div class="v_mainBox">
      <van-form @submit="onSubmit" @failed="onFailed">
        <div class="van-box">
          <div class="van-line1">
            <p class="van-name">{{ stationName }}</p>
            <div class="van-pf">
              <p><span>评分</span>
                <van-rate v-model="value" :size="18" color="#ee0a24" void-icon="star" void-color="#eee"/>
              </p>
            </div>
          </div>
          <div class="van-line2">
            <!-- 评论内容  -->
            <van-field v-model="content" rows="2" autosize type="textarea" maxlength="60"
                       placeholder="亲，您对本次服务是否还满意？您的评价有助于我们更优质的服务哦~" show-word-limit
                       :rules="[{ validator, message: '请输入正确内容' }]"/>
            <!-- 图片内容  -->
            <p class="van-txt">图片上传</p>
            <van-field name="uploader" class="van-imgBox">
              <template #input>
                <van-uploader v-model="uploader" multiple :max-count="3" :preview-size="heightImg"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="margin: 16px;">
          <van-button round block type="primary" icon="success" native-type="submit" :loading="loading"
                      loading-text="评论中...">提交评论
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import carInspectionComment from "@/api/carInspectionComment";

export default {
  name: "comments",
  data() {
    return {
      stationName: '',
      stationId: null,
      orderId: null,
      value: 5,
      content: '',
      uploader: [],
      loading: false,
      heightImg: 80
    };
  },
  created() {
    this.stationName = this.$route.query.stationName
    this.stationId = this.$route.query.stationId
    this.orderId = this.$route.query.orderId
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 表单校验成功
     */
    onSubmit() {
      this.loading = true
      const toast = this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      carInspectionComment.create(this.stationId, this.orderId, this.content, this.value, this.uploader).then(res => {
        // eslint-disable-next-line no-console
        console.log(res)
        this.$notify({type: 'success', message: '评论成功\n两秒后跳转'});
        toast.clear()
        setTimeout(() => {
          this.$router.push({path: '/order'})
        }, 2000);
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    /**
     * 表单校验失败
     * @param errorInfo
     */
    onFailed(errorInfo) {
      // eslint-disable-next-line no-console
      console.log('failed', errorInfo);
      this.$notify({type: 'warning', message: '请检查信息是否填写完整'});
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return val !== '';
    }
  }
}
</script>

<style scoped>
.v_mainBox {
  width: 100%;
  padding-top: 50px;
}

.van-box {
  width: 100%;
  margin: auto;
  height: auto;
  display: block;
  font-size: 14px;
}

/*好评星星*/
.van-line1 {
  width: 100%;
  border-bottom: 5px solid #eee;
  padding-bottom: 5px;
}

.van-line1 p {
  width: 90%;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
}

.van-line1 .van-name {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
}

.van-line1 .van-pf span {
  display: inline-block;
  width: 12%;
}

/*输入文字内容*/
.van-line2 {
  width: 100%;
  height: auto;
  display: block;
  border-bottom: 5px solid #eee;
}

.van-cell {
  width: 90%;
  margin: 10px auto 0 auto !important;
  padding: 0 !important;
  min-height: 90px !important;
  font-size: 13px;
  line-height: 25px !important;
}


.van-cell::after {
  border: none !important;
}

.van-txt {
  width: 90%;
  margin: auto;
  font-size: 12px;
  color: #888;
}

.van-button--primary {
  background-color: #3778d0 !important;
  border: 1px solid #3778d0 !important;
}
</style>
